import MultiplePlaylistsShareModal from './MultiplePlaylistsShareModal'

export default MultiplePlaylistsShareModal
// eslint-disable-next-line import/export
export * from './MultiplePlaylistsShareModal'
